import React, { useState } from "react";
import {
  Box,
  Avatar,
  Typography,
  Card,
  CardContent,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  CreditCard,
  Business,
  EmojiEvents,
  People,
  HelpOutline,
  Star,
  Info,
  Logout,
  ArrowForwardIos,
} from "@mui/icons-material";

import Female from "../../assets/female.png";
import Male from "../../assets/male.png";
import Default from "../../assets/da.png";
import LogoutModal from "./Logout";
import { Link, useNavigate } from "react-router-dom";
import GoogleSuccessModal from "./GoogleSuccessModal";
import GoogleNumberOtpModal from "./GoogleNumberOtpModal";
import BottomNarBar from "../../BottomNav/Bottom";
import AddGoogleNumber from "./AddGoogleNumber";
import EditProfile from "../EditProfile/component";
import GiftIcon from '../../assets/giftCard.png'
import PaymentIcon from '../../assets/payment.png'
import BpLogo from '../../assets/bplogo.png'
import DpLogo from '../../assets/dpLogo.png'

import helpsupporticon from '../../assets/faqicon.png'
import {  IconButton} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const items = [
  { title: "Help & Support",  link: "/faq-help-support", external: false },
  { title: "Refer and Earn", link: "/refer&earn", external: false },
  { title: "FAQ'S",  link: "https://www.daalchini.co.in/faq.html", external: true },
  { title: "About Us",  link: "https://www.daalchini.co.in/", external: true },
];


export default function ProfileScreen({profileData,setProfileData,
    LogoutAllDevice,LogoutCurrentDevice,
    paymentOptionsList,google_success_flag,
    google_OTP_Pop_flag,setOtp,otp,
    googleOtpSubmit,closeOTpPop,google_Pop_flag,
    googleAddnumber,closePop,setNumber,number,numberError,numberErrorMsg,fetchUserDetails,otpErrorMsg,otpError

}) {


    const navigate=useNavigate()
   /// console.log("profileData",profileData,paymentOptionsList)
  const [logoutModal, setLogoutModal] = useState(false);
  const [logoutBtn, setLogoutBtn] = useState(false);
  const [editProfile,setEditProfile]=useState(false)
      const LogoutModalFun = () => {
    setLogoutModal(true);
    setLogoutBtn(false)
  };

   const avatarImage =
    profileData.gender === "female"
      ? Female
      : profileData.gender === "male"
      ? Male
      : Default;


  const DeviceCount=()=>{
  if(profileData?.activeSessionCount&&profileData?.activeSessionCount.length==1){
return profileData&&profileData?.activeSessionCount&&profileData?.activeSessionCount
  }
  else{
    return `${profileData&&profileData?.activeSessionCount&&profileData?.activeSessionCount}`
  }
}

const handlePaymentSettings=()=>{
    //console.log("goto payment Option")
    navigate(`/paymentOptions?route=profile`);
}

const handleTagPay=()=>{
    ///console.log("goto payment Option")
    navigate("/taglist");
}


const handleGiftCard=()=>{
      //console.log("goto payment Option")
    navigate("/giftcard");
}

if(editProfile){
    return(<>
    <EditProfile setEditProfile={setEditProfile} setProfileData={setProfileData} profileData={profileData} fetchUserDetails={fetchUserDetails} />
    
    <BottomNarBar/>
    </>)
}

  const TopNav = () => {
    return (
      <>
      
        <div className="_2456r">
          <div
            
            className="_3nxa7"
            style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        padding: '10px',

      }}
            data-testid="listing-header-location"
          >
            <button
              className="_1NdRR"
              aria-label="Selected address is Delhi, India; Double tap to change address."
              id="change-address-btn-id"
            >
              <div     >
                <h2
                  style={{
                    marginLeft: "25px",
                    fontSize: "18px",
                    color: "#583C43",
                    fontWeight: "500",
                  }}
                >
                  Profile
                </h2>

                <div style={{ marginLeft: "10px" }}></div>
              </div>
            </button>

            <span className="icon-Offers-outline _2P0Ff" />

       {/*    <div onClick={(e)=>{setLogoutBtn(true)}}><svg

              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M8 3.25C8.41421 3.25 8.75 2.91421 8.75 2.5C8.75 2.08579 8.41421 1.75 8 1.75C7.58579 1.75 7.25 2.08579 7.25 2.5C7.25 2.91421 7.58579 3.25 8 3.25Z"
                stroke="#583C43"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8 8.75C8.41421 8.75 8.75 8.41421 8.75 8C8.75 7.58579 8.41421 7.25 8 7.25C7.58579 7.25 7.25 7.58579 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75Z"
                stroke="#583C43"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8 14.25C8.41421 14.25 8.75 13.9142 8.75 13.5C8.75 13.0858 8.41421 12.75 8 12.75C7.58579 12.75 7.25 13.0858 7.25 13.5C7.25 13.9142 7.58579 14.25 8 14.25Z"
                stroke="#583C43"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            </div>  */}
          </div>
        </div>
      </>
    );
  };

const gotobpLink=()=>{
    navigate('/link/bp')
}




const MenuList = () => {
  const items = [
    {
      image: helpsupporticon, // ✅ custom image
      text: "Help & Support",
      type: "internal",
      link: "/faq-help-support",
    },
    {
      icon: <People />,
      text: "Refer & Earn",
      type: "internal",
      link: "/refer&earn",
    },
    {
      icon: <HelpOutline />,
      text: "FAQs",
      type: "external",
      link: "https://www.daalchini.co.in/faq.html",
    },
    {
      icon: <Info />,
      text: "About us",
      type: "external",
      link: "https://www.daalchini.co.in/",
    },
  ];

  return (
    <List>
      {items.map((item, i) => {
        const isExternal = item.type === "external";

        return (
          <ListItem
            key={i}
            button
            divider={i !== items.length - 1}
            component={isExternal ? "a" : Link}
            to={!isExternal ? item.link : undefined}
            href={isExternal ? item.link : undefined}
            target={isExternal ? "_blank" : undefined}
            rel={isExternal ? "noopener noreferrer" : undefined}
            sx={{
              "&:hover": { backgroundColor: "#f4f6fa" },
              textDecoration: "none",
              color: "inherit",
            }}
          >
            {/* LEFT ICON / IMAGE */}
            <ListItemIcon sx={{ minWidth: 40 }}>
              {item.image ? (
                <img
                  src={item.image}
                  alt={item.text}
                  width={22}
                  height={22}
                  style={{ objectFit: "contain" }}
                />
              ) : (
                item.icon
              )}
            </ListItemIcon>

            <ListItemText primary={item.text} />

            <ArrowForwardIos sx={{ fontSize: 16, color: "text.secondary" }} />
          </ListItem>
        );
      })}
    </List>
  );
};



const gotoDpRecharge=()=>{
  navigate('/dphistory')
}


const gotoBpRecharge=()=>{
  navigate('/bphistory')
}

  return (
    <>
    
          {logoutBtn&&<div
            style={{
              background: "#ffffff",
              position: "fixed",
              "z-index": "99",
              right: "17px",
              width: "95px",
              borderRadius: "8px",
              top: "47px",
            }}
          >
            <div
              style={{
              /*   display: "flex",
                "align-items": "center",
                "justify-content": "space-around", */
                height: "62px",
              }}
            >
              <div>
              <h1
                style={{ textAlign: "center", fontWeight: "500", fontSize: "14px" ,padding:"5px"}}
                onClick={(e) => {
                  LogoutModalFun();
                }}
              >
                Log out
              </h1>
              <hr/>
             <Link to="/settings"> <h1
                style={{ textAlign: "center", fontWeight: "500", fontSize: "14px" ,padding:"5px"}}
          
              >
                Settings
    
              </h1>
              </Link>
              </div>
            </div>
          </div>}
          <TopNav/>
         <BottomNarBar />
     {(google_success_flag)&&<GoogleSuccessModal/>}
   {(google_OTP_Pop_flag&&google_OTP_Pop_flag)&&<GoogleNumberOtpModal setOtp={setOtp} otp={otp} googleOtpSubmit={googleOtpSubmit} closeOTpPop={closeOTpPop} google_OTP_Pop_flag={google_OTP_Pop_flag} otpErrorMsg={otpErrorMsg} otpError={otpError}  googleAddnumber={googleAddnumber}/>}
    {(google_Pop_flag)&&!(localStorage.getItem("isGuest"))&&<AddGoogleNumber google_Pop_flag={google_Pop_flag}  googleAddnumber={googleAddnumber}closePop={closePop} setNumber={setNumber} number={number} numberError={numberError}numberErrorMsg={numberErrorMsg}/>}
    <LogoutModal logoutModal={logoutModal} setLogoutModal={setLogoutModal} DeviceCount={DeviceCount} LogoutAllDevice={LogoutAllDevice} LogoutCurrentDevice={LogoutCurrentDevice}/>
    <Box
    onClick={(e)=>{setLogoutBtn(false)}}
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom right, #f7fcff, #f4f7f6)",
        p: 2,
      
                 paddingBottom: "100px",
    paddingTop: "90px",
      }}
    >
   
      {/* Top Profile Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
          p: 2,
          borderRadius: 3,
          //background: "#fff",
          //boxShadow: 1,
        }}
          onClick={(e)=>{setLogoutBtn(false)}}
      >
  {/*       <Avatar
          sx={{
            bgcolor: "#fae14b",
            width: 60,
            height: 60,
            fontWeight: "bold",
            fontSize: 24,
            color: "#384F6F",
          }}
        >
          Da
        </Avatar> */}
        <img src={avatarImage}  style={{width:"70px"}} />
        <Box sx={{ ml: 2, flexGrow: 1 }} onClick={(e)=>{setEditProfile(e)}}>
          <Typography variant="subtitle1" fontWeight="bold">
            {profileData?.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
          {profileData?.mobileNo}
          </Typography>
         {/*   <Typography variant="body2" color="text.secondary">
          {profileData?.emailId}
          </Typography> */}
          <Typography
            variant="body2"
            sx={{ color: "#1A73E8", cursor: "pointer" }}
            onClick={(e)=>{setEditProfile(e)}}
          >
            View or edit profile
          </Typography>
        </Box>
        <ArrowForwardIos sx={{ fontSize: 16, color: "text.secondary" }}  onClick={(e)=>{setEditProfile(e)}} />
      </Box>

      {/* Settings Cards */}
      <Box  sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <Card onClick={(e)=>{handlePaymentSettings(e)}} sx={{ borderRadius: 3, boxShadow: 1 }} style={{    borderLeft:"4px solid #583c43",borderRadius: "12px"}}>
          <CardContent sx={{ display: "flex", alignItems: "center" ,pb:"0"}}   style={{paddingBottom:"13px"}}>
           <img src={PaymentIcon} style={{width:"40px",height:"40px",marginRight:"10px"}}/>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="subtitle1" fontWeight="500">
                Payment Settings
              </Typography>
            </Box>
            <ArrowForwardIos sx={{ fontSize: 16, color: "text.secondary" }} />
          </CardContent>
        </Card>

<Card
  onClick={handleTagPay}
  sx={{
    borderLeft: "4px solid #4b33a1",
    borderRadius: "12px",
    boxShadow: 1,
    pb: 0,
    cursor: "pointer",
    "&:hover": {
      boxShadow: 3,
    },
  }}
>
  <CardContent
    sx={{
      display: "flex",
      alignItems: "center",
      pb: "0", // ✅ works in sx
     
    }}
    style={{paddingBottom:"13px"}}
  >
    <Box
      sx={{
        backgroundColor: "#583C4314",
        borderRadius: "40px",
        width: 50,
        height: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mr: 1,
      }}
    >
      <CreditCard sx={{ color: "#5B4B8A", fontSize: 28 }} />
    </Box>

    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="subtitle1" fontWeight={500}>
        TagPay
      </Typography>
    </Box>

    <ArrowForwardIos sx={{ fontSize: 16, color: "text.secondary" }} />
  </CardContent>
</Card>


 

        <Card
          sx={{
            borderRadius: 3,
            boxShadow: 1,
            border: "1px solid #e0f2f1",
          }}
        >
          <CardContent sx={{ display: "flex", alignItems: "center", pb: "0",}}  style={{    paddingBottom:"13px",  borderLeft:"4px solid #4d8e44ff",borderRadius: "12px"}}
          

  
          >
             <img src={BpLogo} style={{width:"40px",height:"40px",marginRight:"10px"}}/>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="subtitle1" fontWeight="500">
                Business Account
              </Typography>
              <Typography variant="body2" color="text.secondary" style={{fontSize:"11px"}}>
                Pay with your company expenses
              </Typography>
            </Box>
            {paymentOptionsList[2]?.balance?
                    <Button
             style={{fontSize:"11px"}}
              variant="contained"
              size="small"
               
              sx={{
                borderRadius: 3,
                textTransform: "none",
                fontSize: 12,
                background: "#E8F5E9",
                color: "#388E3C",
               
                "&:hover": { background: "#E8F5E9" },
              }}
              onClick={(e)=>{gotoBpRecharge(e)}}
            >
             {paymentOptionsList[2]?.balance}  PTS
            </Button>:<Button
              variant="outlined"
              size="small"
              sx={{
                borderRadius: 3,
                textTransform: "none",
                fontSize: 12,
                borderColor: "#009688",
                color: "#009688",
              }}
              onClick={(e)=>{gotobpLink()}}
            >
              Link
            </Button>}
          </CardContent>
        </Card>

        <Card  sx={{ borderRadius: 3, boxShadow: 1 }}  style={{    borderLeft:"4px solid rgb(250 225 75)",borderRadius: "12px"}}>
          <CardContent sx={{ display: "flex", alignItems: "center",pb:0 }}   style={{paddingBottom:"13px"}}>
              <img src={ DpLogo} style={{width:"40px",height:"40px",marginRight:"10px"}}/>
           
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="subtitle1" fontWeight="500">
                Daalchini Points
              </Typography>
            </Box>
            <Button
             
              variant="contained"
              size="small"
              sx={{
                borderRadius: 3,
                textTransform: "none",
                fontSize: 12,
                background: "#E8F5E9",
                color: "#388E3C",
                "&:hover": { background: "#E8F5E9" },
              }}
              onClick={(e)=>{gotoDpRecharge(e)}}
            >
             {paymentOptionsList[3]?.balance}  PTS
            </Button>
          </CardContent>
        </Card> <Card onClick={(e)=>{handleGiftCard(e)}} sx={{ borderRadius: 3, boxShadow: 1 }}>
          <CardContent sx={{ display: "flex", alignItems: "center",pb:0 ,}}   style={{paddingBottom:"13px"}}>
            <div style={{backgroundColor:"#583C4314",borderRadius:"40px",width:"50px",height:"50px",display:"flex",alignItems:"center",justifyContent:"center",marginRight:"8px"}}>
            <img  src={GiftIcon} style={{height:"20px",}} />
            </div>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="subtitle1" fontWeight="500">
                Gift Card
              </Typography>
            </Box>
            <ArrowForwardIos sx={{ fontSize: 16, color: "text.secondary" }} />
          </CardContent>
        </Card>

      </Box>


      {/* Other Options */}
      <Box sx={{ mt: 3, borderRadius: 3, background: "#fff", boxShadow: 1 }}>
<MenuList/>
      </Box>

      {/* Logout */}
      <Box sx={{ mt: 3 }}>
        <Card
          sx={{
            borderRadius: 3,
            textAlign: "center",
            p: 1,
            boxShadow: 1,
            background: "#fff",
            cursor: "pointer",
          }}
        >
          <Box onClick={(e)=>{LogoutModalFun(e)}} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} >
            <Logout sx={{ fontSize: 18, color: "#D32F2F", mr: 1 }} />
            <Typography sx={{ color: "#D32F2F", fontWeight: 500 }}>Log out</Typography>
          </Box>
        </Card>
      </Box>
    </Box>
    </>
  );
}
